module.exports = __webpack_public_path__ + "img/arrow-active.f70e8b04.svg";